import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { KeyRound, ArrowLeft, Infinity as InfinityIcon } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (e) {
      setErr(formatApiErrorDetail(e?.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F3F8F7] text-[#212121] px-6">
      <div className="w-full max-w-md k-card p-10">
        <div className="flex items-center gap-2 mb-8">
          <InfinityIcon className="h-7 w-7 text-[#156F5B]" strokeWidth={2.5} />
          <span className="text-2xl font-bold font-heading text-[#156F5B]">KOIOC</span>
        </div>
        <div className="k-label flex items-center gap-2">
          <KeyRound className="h-3.5 w-3.5" /> Account recovery
        </div>
        <h1 className="mt-3 text-3xl font-bold font-display text-[#212121]">Forgot password</h1>

        {sent ? (
          <div className="mt-8 rounded-md border border-[#B9D6CE] bg-[#F3F8F7] px-5 py-4 text-sm text-[#212121]" data-testid="forgot-success">
            If that email exists, a reset link has been sent. Check your inbox — the link expires in 1 hour.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-6" data-testid="forgot-form">
            <p className="text-[#4D4D4D] text-sm">
              Enter your account email and we&apos;ll send you a link to reset your password.
            </p>
            <div>
              <label className="k-sublabel">Email</label>
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email-input"
                className="k-input mt-2"
                placeholder="you@company.com"
              />
            </div>
            {err && (
              <div className="text-sm text-red-700 rounded-md border border-red-200 bg-red-50 px-4 py-2" data-testid="forgot-error">
                {err}
              </div>
            )}
            <button type="submit" disabled={busy} data-testid="forgot-submit-button" className="k-btn">
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}

        <div className="mt-8 text-xs">
          <Link to="/login" className="inline-flex items-center gap-1 text-[#156F5B] font-semibold hover:underline" data-testid="back-to-login-link">
            <ArrowLeft className="h-3 w-3" /> Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
